import { render, staticRenderFns } from "./TournamentHero.vue?vue&type=template&id=a2eb4ce0&"
import script from "./TournamentHero.vue?vue&type=script&lang=js&"
export * from "./TournamentHero.vue?vue&type=script&lang=js&"
import style0 from "./TournamentHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports